import { Injectable } from '@angular/core';
import {environment} from '../../../../../../../src/environments/environment';

export enum EnvironmentType {
  website = 'website',
  reporter = 'reporter',
  widget = 'widget',
}

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  private static _type: EnvironmentType | null = null;

  static get type(): EnvironmentType {
    if (EnvironmentService._type === null) {
      EnvironmentService._type = EnvironmentService.detectEnvironmentType();
    }
    return EnvironmentService._type;
  }

  static get isWidget(): boolean {
    return EnvironmentService.type === EnvironmentType.widget;
  }

  static get isWebsite(): boolean {
    return EnvironmentService.type === EnvironmentType.website;
  }

  static get isReporter(): boolean {
    return EnvironmentService.type === EnvironmentType.reporter;
  }

  // TODO: @nulpe bitte hier genau drüberschauen
  // TODO: Check for reporter environment as well
  private static detectEnvironmentType(): EnvironmentType {
    // Check for project environment first
    if (environment?.projectType === 'website') {
      return EnvironmentType.website;
    }

    if (environment?.projectType === 'widgets') {
      // Only in local environment
      return EnvironmentType.widget;
    }

    // Check for iFrame implementation
    try {
      const isInIFrame = window.self !== window.top;
      console.log('DBG embedded in iFrame', isInIFrame);
      return isInIFrame ? EnvironmentType.widget : EnvironmentType.website;
    } catch {
      // Can fail on CORS restriction -> is iFrame
      return EnvironmentType.widget;
    }
  }
}
